import { convertToReadable, percentToGB } from "@sscs/utils";

export const getPercentageHelperText = (
  percentage: number | null,
  limited: number,
): string => {
  const bytes =
    percentage === null || isNaN(percentage) || isNaN(limited)
      ? 0
      : percentToGB(percentage, limited);
  return `(${convertToReadable(bytes)})`;
};
